export default __webpack_public_path__ + "/public/icons/m-treat-doctor.jpg";